import { createRouter, createWebHistory } from 'vue-router'
import ResultsView from '../components/ResultsView.vue'
import LiveResultsView from '../components/LiveResultsView.vue'
import SplitsView from '../components/SplitsView.vue'
import ArResultsView from '../components/ArResultsView.vue'
import StatsView from '../components/StatsView.vue'

const routes = [
  {
    path: '/:eventAlias',
    name: 'Results',
    component: ResultsView
  },
    {
        path: '/live/:eventAlias',
        name: 'LiveResults',
        component: LiveResultsView
    },
    {
        path: '/splits/:eventAlias',
        name: 'Splits',
        component: SplitsView
    },
    {
        path: '/ar/:eventAlias',
        name: 'ArResults',
        component: ArResultsView
    },
    {
        path: '/stats/:eventAlias',
        name: 'Stats',
        component: StatsView
    },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router